
/** 网络、接口 相关配置 **/
export const axiosConfig = {
  // 获取配置信息
  apiUserRegisterOcpcPath: "/api/user/register/ocpc",
  // 发送验证码
  apiUserRegisterMobileCodeSemPath: "/api/user/register/mobile/code/sem/",
  // 发送验证码-需要滑动验证
  apiUserRegisterMobileCodeSlidingVerifySemPath: "/api/user/semLogin/mobile/code/sem/with-registered-flag",
  // 验证验证码
  apiUserRegisterVerifyMobileCodeSemPath: "/api/user/register/code/validate/sem/",
  // 注册
  apiUserCompleteRegisterSemPath: "/api/user/register/regist/sem/new/",
  // 登录获取验证码
  apiUserLoginVerifyMobileCodeSemPath: "/api/user/semLogin/mobile/code/sem/",
  // 登录
  apiUserCompleteLoginSemPath: "/api/user/semLogin/mesLogin",
  // 验证验证码
  apiUserRegisterCodeValidateSemPath: "/api/user/register/code/validate/sem/",
  // 注册
  apiUserRegisterSemNewPath: "/api/user/register/regist/sem/new/",
  // 获取添加到通讯录链接
  apiUserCpLinkPath: "/api/user/cp/link",
  // 获取验证码埋点
  burypointRegisterMonitorGetRegisterCodePointPath: "/burypoint/register/monitor/addRegisterCodePoint",
  // 注册成功埋点
  burypointRegisterMonitorCompleteRegisterPointPath: "/burypoint/register/monitor/updateRegisterCodePoint",
  // 获取用户信息
  restUCompanyGetCompanyInfoPath: "/rest/u/company/getCompanyInfo",
  // 获取小程序二维码接口
  restULoginQrCodeUnionIdLoginPath: "/rest/u/loginQrCode/getLoginQrCode",
  // 小程序二维码轮询接口
  restULoginQrCodeGetLoginQrCodeStatePath: "/rest/u/loginQrCode/getLoginQrCodeState",
  //获取用户是否完善信息
  isImproveInformationPath: "/api/user/register/isImproveInformation",
  //完善信息接口
  qrcodeImproveInformationPath: "/api/user/register/qrcodeImproveInformation",
  //完善用户信息
  restUPersonalMembersInfoUpdatePath: "/rest/u/personal/members/info/update",
  // 账号密码登录接口
  restUApiUserPhoneLoginPath: "/rest/u/api/user/phone/login",

  apiUserCaptchaGetPath: "/api/user/captcha/get",
  apiUserCaptchaCheckPath: "/api/user/captcha/check",
  apiUserCaptchaNoLoginCheckPath: "/api/user/captcha/nologin/check",
  // 模板8列表数据
  apiTem8DataListPath: "/gw/semAdvert/search",
  //模板2公告列表接口
  getTempleteTwoPath: "/service/api/v1/sem/getTempleteNotices",
  //埋点接口
  burypointEventCollectPath: "/burypoint/event/collect",
  //指纹接口
  burypointBehaviorInsertRecordFromSearchEnginesPath: "/burypoint/user/behavior/insertRecordFromSearchEngines",
  //新注册调查问卷 api/user/register/regist/sem/questionnaire/
  apiUserRegisterSemQuestionnairePath: "/api/user/register/regist/sem/questionnaire/",
  //显示问卷类型还是表单类型/burypoint/questionnaire/showstatus
  burypointQuestionnaireShowstatusPath: "/burypoint/questionnaire/showstatus",


  apiUserCompleteInfoSemPath: "/api/user/semLogin/improveInformation",

  //不注册发送短信 /api/user/register/phonecode/
  apiUserRegisterPhonecodePath: "/api/user/register/phonecode/",
  //不注册验证短信码 /api/user/register/phonecode/validate/
  apiUserRegisterPhonecodeValidatePath: "/api/user/register/phonecode/validate/",
  //保存问卷信息 /api/user/register/sem/questionnaire/
  apiUserRegisterSemQuestionnaireSavePath: "/api/user/register/sem/questionnaire/",

  //模版调研用的 /api/user/register/testpage/mobile/code
  apiUserRegisterTestpageMobileCodePath: "/api/user/register/testpage/mobile/code",
  //模版调研用的 /api/user/register/testpage/regist
  apiUserRegisterTestpageRegistPath: "/api/user/register/testpage/regist",
  // SEM标讯搜索接口
  apiSemSearchPath: "/service/api/v1/website/semSearch",
  //api/v1/sem/semKeywordSearch?keyword= 
  apiSemKeywordSearchPath: "/service/api/v1/sem/semKeywordSearch",
  //新的验证码接口 user/register/mobile/code/sem/new/
  apiUserRegisterMobileCodeSemNewPath: "/api/user/register/mobile/code/sem/new/",
   //新验证码校验接口 user/register/code/validate/sem/new/ 
   apiUserRegisterCodeValidateSemNewPath: "/api/user/register/code/validate/sem/new/",
  // common
  HTTP_CODE: {
    SUCCESS: 200,
    UNAUTHORIZED: 401,
    REDO_LOGIN: 406,
  },

  STATUS_CODE: {
    SUCCESS: 200,
    SERVER_ERR: 503,
    PHONE_REGISTERED: 100007, // 手机号已经被注册
    VIEWS_OFFLINE: 100017, // 页面已下线
    TRY_PSD_LOGIN: 100018, // 请尝试使用密码登录
    NEED_ACCESS_CAPTCHA_PERMISSION: 100403, // 缺少ACCESS-CAPTCHA-PERMISSION
  },

  API_TYPE: {
    USER: "USER",
    API: "API",
    OSS: "OSS",
    HOME: "HOME",
    SEARCH: "SEARCH",
  },
};
